import {
  ChefMenuItem,
  CreateChefMenuItemReq,
  EditChefMenuItemReq,
} from 'types/groupOrder/menuItemMods'
import { CateringChefMenuItem } from 'types/chefs/menuitems'

type QueryParams = Record<
  string,
  string | number | boolean | string[] | number[]
>

interface GetChefMenuItemCoordinator {
  RestService: {
    get<T = unknown>(path: string, options?: QueryParams): Promise<T>
  }
  HandleError: any
  pGetRelatedChefMenuItemIds: (chefMenuItem: ChefMenuItem) => string[]
  pResponseChefMenuItem: (
    chefMenuItem: ChefMenuItem,
    cateringItems: Partial<CateringChefMenuItem>[],
  ) => ChefMenuItem
}

export const GetChefMenuItem =
  ({
    RestService,
    pGetRelatedChefMenuItemIds,
    pResponseChefMenuItem,
  }: GetChefMenuItemCoordinator) =>
  async (chefMenuItemId: string): Promise<ChefMenuItem | null> => {
    try {
      const menuItem = await RestService.get<ChefMenuItem>(
        `group-orders/chef-menu-items/${chefMenuItemId}`,
      )

      let items: Partial<CateringChefMenuItem>[] = []
      const ids = pGetRelatedChefMenuItemIds(menuItem)
      if (ids.length > 0) {
        items = await RestService.get<Partial<CateringChefMenuItem>[]>(
          '/api/admin/menu_items',
          { ids: ids },
        )
      }

      return pResponseChefMenuItem(menuItem, items)
    } catch (error) {
      return null
    }
  }

interface CreateChefMenuItemCoordinator {
  RestService: {
    post: (path: string, req: CreateChefMenuItemReq) => Promise<ChefMenuItem>
  }
  HandleError: any
  pResponseChefMenuItem: (chefMenuItem: ChefMenuItem) => ChefMenuItem
}

export const CreateChefMenuItem =
  ({
    RestService,
    HandleError,
    pResponseChefMenuItem,
  }: CreateChefMenuItemCoordinator) =>
  async (req: CreateChefMenuItemReq): Promise<ChefMenuItem | null> => {
    try {
      const menuItem = await RestService.post(
        `group-orders/chef-menu-items`,
        req,
      )

      return pResponseChefMenuItem(menuItem)
    } catch (error) {
      HandleError({ error })

      return null
    }
  }

interface EditChefMenuItemCoordinator {
  RestService: {
    put: (path: string, req: EditChefMenuItemReq) => Promise<ChefMenuItem>
    get: (
      path: string,
      req: Record<string, any>,
    ) => Promise<Partial<CateringChefMenuItem>[]>
  }
  HandleError: any
  pGetRelatedChefMenuItemIds: (chefMenuItem: ChefMenuItem) => string[]
  pResponseChefMenuItem: (
    chefMenuItem: ChefMenuItem,
    cateringItems: Partial<CateringChefMenuItem>[],
  ) => ChefMenuItem
}

export const EditChefMenuItem =
  ({
    RestService,
    HandleError,
    pGetRelatedChefMenuItemIds,
    pResponseChefMenuItem,
  }: EditChefMenuItemCoordinator) =>
  async (req: EditChefMenuItemReq): Promise<ChefMenuItem | null> => {
    try {
      const menuItem = await RestService.put(
        `group-orders/chef-menu-items/${req.id}`,
        req,
      )
      let items: Partial<CateringChefMenuItem>[] = []
      const ids = pGetRelatedChefMenuItemIds(menuItem)
      if (ids.length > 0) {
        items = await RestService.get('/api/admin/menu_items', { ids: ids })
      }

      return pResponseChefMenuItem(menuItem, items)
    } catch (error) {
      HandleError({ error })

      return null
    }
  }
